<template>
  <div>
    
    <el-row :gutter="12" class="mt-2" v-loading.fullscreen.lock="reports.isLoading || exportReport.isLoading">
      <el-row type="flex" justify="space-between" align="middle" class="mb-4">
        <p class="category-title ma-0">Report</p>

        <el-col :span="16">
          <el-row type="flex" justify="end">
            <el-button type="primary" @click="dialogFormVisible = true" size="small">Advanced filter</el-button>
            <el-button type="danger" @click="handleResetFilter" size="small">Reset filter</el-button>
            <el-button type="success" @click="handleExportToExcel" size="small">Export to excel</el-button>
          </el-row>
        </el-col>
      </el-row>
      

      <el-col :span="24">
        <el-table empty-text="Tidak ada data" :data="reports.data" style="width: 100%">
          <el-table-column sortable prop="branchCodeData" label="Branch" width="130"></el-table-column>
          <el-table-column sortable prop="orderId" label="Order ID" width="130"></el-table-column>
          <el-table-column sortable prop="status" label="Status Order" width="180">
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.status === 'payment_confirmation'"
                effect="dark"
              >Menunggu Pembayaran</el-tag>
              <el-tag
                v-else-if="scope.row.status === 'pending'"
                type="danger"
                effect="dark"
              >Tertunda</el-tag>
              <el-tag
                v-else-if="scope.row.status === 'on_progress'"
                type="info"
                effect="dark"
              >Dalam Proses</el-tag>
              <el-tag
                v-else-if="scope.row.status === 'delivery'"
                type="warning"
                effect="dark"
              >Dalam Pengiriman</el-tag>
              <el-tag v-else-if="scope.row.status === 'done'" type="success" effect="dark">Selesai</el-tag>
            </template>
          </el-table-column>
          <el-table-column sortable prop="customerName" label="Customer Name" width="180"></el-table-column>
          <el-table-column sortable prop="customerId" label="Customer ID" width="140"></el-table-column>
          <el-table-column sortable prop="paymentMethod" label="Payment Method" width="180"></el-table-column>
          <el-table-column sortable prop="totalValue" label="Total Value" width="180"></el-table-column>
          <el-table-column
            v-if="modeShow"
            sortable
            prop="paymentStatus"
            align="center"
            label="Status Payment"
            width="180"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.paymentStatus === 'waiting_for_approval'"
                effect="dark"
              >Menunggu Persetujuan</el-tag>
              <el-tag
                v-if="scope.row.paymentStatus === 'on_progress'"
                effect="dark"
              >On Progress</el-tag>
              <el-tag
                v-else-if="scope.row.paymentStatus === 'done'"
                type="success"
                effect="dark"
              >Selesai</el-tag>
              <div v-else-if="scope.row.paymentStatus === '-'">-</div>
            </template>
          </el-table-column>
          <el-table-column sortable label="Created/Updated at" width="180">
            <template slot-scope="scope">
              {{ scope.row.created }}/
              <br />
              {{ scope.row.updated }}
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end">
          <el-pagination
            layout="prev, pager, next"
            :total="reports.count"
            :current-page="parseInt(page)"
            @current-change="
            e => {
              toAnotherPage(e, optionView), settingTable(e, optionView);
            }
          "
            :page-size="parseInt(optionView)"
          ></el-pagination>
        </el-row>
      </el-col>
    </el-row>

    <!-- Dialog form filter -->
    <el-dialog title="Filter Report" :visible.sync="dialogFormVisible">
      <el-form :model="form" :label-width="formLabelWidth">
        <el-form-item label="Branch">
          <el-select 
            ref="branchCode"
            filterable
            remote
            :remote-method="onSearchBranchs"
            :loading="branchs.onLoading"
            v-model="form.branch" 
            placeholder="Please select a branch" 
            multiple 
            style="width: 60%" 
            size="small">
            <el-option
              v-for="item in branchs.data.map(item => {
                item.name = `${item.branchCode} - ${item.branch}`;
                item.value = item.branchCode;
                return item;
              })"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
            <el-row type="flex" justify="center">
              <el-button
                :loading="branchs.isLoading"
                size="mini"
                round
                @click="loadMoreBranch"
              >Load More</el-button>
            </el-row>
          </el-select>
        </el-form-item>
        <el-form-item label="Status Order">
          <el-select v-model="form.status_order" placeholder="Please select a status order" multiple style="width: 60%" size="small">
            <el-option label="Dalam Proses" value="on_progress"></el-option>
            <el-option label="Pending" value="pending"></el-option>
            <el-option label="Selesai" value="done"></el-option>
            <el-option label="Konfirmasi Pembayaran" value="payment_confirmation"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Payment Method">
          <el-select v-model="form.payment_method" placeholder="Please select a status order" multiple style="width: 60%" size="small">
            <el-option label="COD" value="COD"></el-option>
            <el-option label="TOP" value="TOP"></el-option>
            <el-option label="Bank Transfer" value="BT"></el-option>
            <el-option label="Payment Gateway" value="PG"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Payment Status">
          <el-select v-model="form.payment_status" placeholder="Please select a payment status" multiple style="width: 60%" size="small">
            <el-option label="Menunggu Persetujuan" value="waiting_for_approval"></el-option>
            <el-option label="Dalam Proses" value="on_progress"></el-option>
            <el-option label="Selesai" value="done"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Date Range">
          <el-date-picker
            v-model="form.date_range"
            class="custom-date-range"
            style="width: 60%"
            type="daterange"
            size="small"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date">
          </el-date-picker>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="small">Cancel</el-button>
        <el-button type="primary" @click="dialogFormVisible = false; advancedFilter()" size="small">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      dialog: false,
      id: null,
      modeShow: true,
      optionView: 25,
      limitBranch: 25,
      page: 1,
      dialogFormVisible: false,
      form: {
        branch: [],
        status_order: [],
        payment_method: [],
        payment_status: [],
        date_range: ''
      },
      formLabelWidth: '200px',
      searchBranch: '',
    };
  },
  mounted() { },
  methods: {
    ...mapActions({
      getReports: "report/GetReports",
      getBranch: "branch/GetBranchs",
      getPaymentTypes: "paymentType/GetPaymentTypes",
      exportToExcel: "report/ExportToExcelReport",
    }),
    paramsPayload() {
      let payload = {}
      if (this.form.date_range !== '') {
        payload.startDate = moment(this.form.date_range[0]).format('YYYY-MM-DD')
        payload.endDate = moment(this.form.date_range[1]).format('YYYY-MM-DD')
      }

      this.form.branch.map((item, idx) => {
        payload[`branchCode[${idx}]`] = item
      });
      this.form.status_order.map((item, idx) => {
        payload[`orderStatus[${idx}]`] = item
      });
      this.form.payment_method.map((item, idx) => {
        payload[`paymentCode[${idx}]`] = item
      });
      this.form.payment_status.map((item, idx) => {
        payload[`paymentStatus[${idx}]`] = item
      });
      return payload;
    },
    toAnotherPage(page, limit) {
      this.$router.push({ path: "/reports", query: { page: page, limit: limit, } });
    },
    async settingTable() {
      this.page = this.$router.history.current.query.page || 1;
      this.optionView = this.$router.history.current.query.limit || 25;
      const resultParam = await this.paramsPayload();
      let option = {
        params: {
          page: this.page,
          limit: this.optionView,
          ...resultParam 
        }
      };
      this.getReports(option);
    },
    onSearchBranchs(search) {
      this.searchBranch = search;
      let option = {
        params: {
          page: 1,
          limit: 25,
          search: search
        }
      };
      this.getBranch(option);
    },
    loadMoreBranch() {
      this.$refs.branchCode.focus();
      this.limitBranch += 25;
      let option = {
        params: {
          page: 1,
          limit: this.limitBranch,
          search: this.searchBranch
        }
      };
      this.getBranch(option);
    },
    loadMorePaymentTypes() {
      this.limitCategory += 25;
      let option = {
        params: {
          page: 1,
          limit: this.limitCategory,
        }
      };
      this.getPaymentTypes(option);
    },
    async advancedFilter() {
      this.$router.push({ path: "/reports", query: { page: 1, limit: 25, } });
      this.page = this.$router.history.current.query.page || 1;
      this.optionView = this.$router.history.current.query.limit || 25;
      const resultParam = await this.paramsPayload();
      let option = {
        params: {
          page: this.page,
          limit: this.optionView,
          ...resultParam 
        }
      };
      this.getReports(option);
    },
    handleResetFilter() {

      this.form = {
        branch: [],
        status_order: [],
        payment_method: [],
        payment_status: [],
        date_range: ''
      };

      this.$router.push({ path: "/reports", query: { page: 1, limit: 25, } });
      this.page = this.$router.history.current.query.page || 1;
      this.optionView = this.$router.history.current.query.limit || 25;
      let option = {
        params: {
          page: this.page,
          limit: this.optionView,
        }
      };
      this.getReports(option);
    },
    async handleExportToExcel() {
      this.$router.push({ path: "/reports", query: { page: 1, limit: 25, } });
      this.page = this.$router.history.current.query.page || 1;
      this.optionView = this.$router.history.current.query.limit || 25;
      const resultParam = await this.paramsPayload();
      let option = {
        params: {
          page: this.page,
          limit: this.optionView,
          isExport: true,
          ...resultParam 
        }
      };
      this.exportToExcel(option);
    }
  },
  computed: {
    ...mapState({
      reports: state => state.report.reports,
      exportReport: state => state.report.exportReport,
      branchs: state => state.branch.branchs,
      paymentTypes: state => state.paymentType.paymentTypes,
    })
  },
  created() {
    this.page = this.$router.history.current.query.page || 1;
    this.optionView = this.$router.history.current.query.limit || 25;
    let option = {
      params: {
        page: this.page,
        limit: this.optionView,
      }
    };
    let optionBranch = {
      params: {
        page: 1,
        limit:25,
      }
    };
    this.getReports(option);
    this.getBranch(optionBranch);
    this.getPaymentTypes(option);
  }
};
</script>

<style>
.custom-date-range .el-range-separator {
  width: 10% !important;
}
</style>
